<template>
    <div data-zoom-image-container>
        <img
            :src="src"
            :alt="alt"
            :id="id"
            data-is-clickable
            @click="onMainImageClick"
            @dragstart="onDragStart"
            @touchstart="onDragStart"
        />
        <dialog 
            v-if="imageIsClicked === true"
            ref="image-dialog"
            @click="onDialogClick"
            @close="onDialogClose"
        >
            <img
                :src="src"
                :alt="alt"
            />
        </dialog>
        <div data-zoom-option>
            <button
                data-button
                data-zoom-button
                :id="`zoom-button-${id}`"
                ref="zoom-button"
                @click="onMainImageClick()"
            >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path d="M344 0L488 0c13.3 0 24 10.7 24 24l0 144c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-87 87c-9.4 9.4-24.6 9.4-33.9 0l-32-32c-9.4-9.4-9.4-24.6 0-33.9l87-87L327 41c-6.9-6.9-8.9-17.2-5.2-26.2S334.3 0 344 0zM168 512L24 512c-13.3 0-24-10.7-24-24L0 344c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39 87-87c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8z"/></svg>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: `zoom-image`,
    data(){
        return {
            imageIsClicked: false
        }
    }, 
    props: {
        src: {
            type: String,
            required: true
        },
        id: {
            type: String,
            required: true,
        },
        alt: {
            type: String
        },
        showPopupOnClick: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        onMainImageClick(e) {
            this.$emit('element-clicked', e);

            if(this.showPopupOnClick === false) return;

            this.imageIsClicked = true;

            this.$emit('element-clicked', e);

            this.$nextTick(() => {
                this.$refs['image-dialog'].showModal();
            });
        },
        onDialogClose(e){
            this.imageIsClicked = false;
            e.target.close();
        },
        onDialogClick: function (e) {
            if (e.target.localName === 'dialog') {
                this.imageIsClicked = false;
                e.target.close();
            }
        },
        onDragStart: function(e){
            this.$emit('dragStart', e);
        }
    }
}
</script>

<style scoped>
[data-is-clickable] {
    max-width: 100%;
}
[data-zoom-image-container] {
    position: relative;
}
[data-zoom-option] {
    position: absolute;
    right: 7px;
    bottom: 11px;
    z-index: 999;
}
[data-zoom-button] {
    border: 0;
    border-radius: 35px;
    width: 50px;
    height: 50px;
    background: var(--primary-color);
    svg {
        height: 25px;
        path {
            fill: #FFF;
        }
    }
}
</style>